export const imageExtensions = Object.freeze(['bmp', 'gif', 'jpeg', 'jpg', 'png']);
